export const measurableIds = [
	'roof', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'floor', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'flooring', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'frame', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouse', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'rafters', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'lintel', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseFoundation', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseFoundationBasement', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseRoofing', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseExteriorFinishes', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseFraming', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseDimensionalFloorRoofLayoutFloorJoistLayout', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseDimensionalFloorRoofLayoutCeilingJoistLayout', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseDimensionalFloorRoofLayoutRoofRafterLayout', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseDrywall', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseInsulation', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
	'wholeHouseMillwork', // added to libs/shared/constants/src/constants/report/Volumetrics.ts totals
] as const;

export const uniqueTrussTypesIds = [
	'roof', // added to libs/shared/constants/src/constants/report/Volumetrics.ts uniqueTrussTypes
	'floor', // added to libs/shared/constants/src/constants/report/Volumetrics.ts uniqueTrussTypes
	'rafters', // added to libs/shared/constants/src/constants/report/Volumetrics.ts uniqueTrussTypes
] as const;
